import React from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import FormikContainer from "../../components/Formik/FormikContainer";
import FieldContainer from "../../components/Formik/FieldContainer";
import { Form } from "formik";

//import utils
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query";
import orderServices from "../../services/orders";
import * as Yup from "yup";
import DButton from "../../components/DButton";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-hot-toast";
const statusOption = [
    {
        id: 1,
        title: "اختر..",
        value: "",
    },
    {
        id: 2,
        title: "نجح",
        value: "success",
    },
    {
        id: 3,
        title: "فشل",
        value: "failed",
    },
    {
        id: 4,
        title: "في الانتظار",
        value: "inprogress",
    },
];

const validationSchema = Yup.object().shape({
    status: Yup.string().required("هذا الحقل مطلوب"),
});
const EditOrder = ({ title }) => {
    const { id } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { data, isLoading, error } = useQuery(["getOrder", id], () =>
        orderServices.getOrder(id)
    );

    const onSubmit = (values, { setSubmitting }) => {
        orderServices
            .updateOrderStatus(id, values.status)
            .then(res => {
                toast.success("تم تحديث الطلب");
                queryClient.refetchQueries(["progressOrders", "totalOrders"]);
                setTimeout(() => {
                    navigate("/orders", { replace: true });
                }, 1500);
            })
            .catch(err => {
                if (err?.response.status === 404) {
                    toast.error("هذا الطلب غير موجود");
                } else {
                    toast.error("فشل تحديث الطلب");
                }
                setSubmitting(false);
            });
    };
    if (error || isNaN(Number(id)) || !id) {
        return <Navigate to="/404" />;
    }
    return (
        <div>
            <PageHeading>
                {title} {id}
            </PageHeading>
            <DCard className={isLoading ? "min-h-[400px]" : ""}>
                {isLoading ? (
                    <DSpinner />
                ) : (
                    <FormikContainer
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        initialValues={{ status: data.data.status }}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="w-full md:w-[200px] mx-auto">
                                    <FieldContainer
                                        type="select"
                                        name="status"
                                        label="حالة الطلب"
                                        options={statusOption}
                                    />
                                </div>
                                <DButton
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="mx-auto min-w-[150px] flex items-center justify-center text-white"
                                >
                                    {isSubmitting ? <Spinner /> : "تحديث"}
                                </DButton>
                            </Form>
                        )}
                    </FormikContainer>
                )}
            </DCard>
        </div>
    );
};

export default EditOrder;
